import styleInject from './../external/.pnpm/style-inject@0.3.0/external/style-inject/dist/style-inject.es.js';

var css_248z = "";
var spacing = {"spacing":"8px"};
styleInject(css_248z);

export { spacing as default };
